import { getFolderName } from './getFolderName';

export const getFolderNameCustomData = (folderId: string) => ({
    Folder: getFolderName(folderId),
});
